module.exports = __webpack_public_path__ + "img/lgpd.355c4d82.svg";